import React, { Component } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import './NavMenu.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    handleLogout(e) {
        localStorage.removeItem('accesstoken');
        return window.location = "/login";
    }

    render() {
        return (
            <div>
                <div className="wrap blue-1">
                    <div id="siteLogoContainer">
                        <div className="container text-center">
                            <div className="align-bottom">
                                <img src="logo_tcoe_white_lg.png" alt="Tulare County Office of Education logo" className="logo-header" title="TCOE logo" />
                            </div>
                        </div>
                    </div>
                </div>
                <div id="menuArea" className="blue-2">
                    <div id="menuAreaContents">
                        <div className="row margin-right-0">
                            <div className="col-lg-1 col-2">
                            </div>
                            <div className="col-lg-10 col-7 text-center">
                                {/* TODO: Add items to center of nav bar */}
                            </div>
                            <div className="col-lg-1 col-2">
                                <UncontrolledDropdown className="dropdown">
                                    <DropdownToggle className="btn dropdown-toggle blue-2" type="button" data-toggle="dropdown"
                                        tag="button" alt="Drop down menu to log out or navigate to My Phoenix">
                                        <img src={this.props.profileImage} style={{ width: '25px' }} alt='Avatar for Phoenix member' title="Avatar for Phoenix member" />
                                        <span className="caret"></span>
                                    </DropdownToggle>
                                    <DropdownMenu className="dropdown-menu dropdown-menu-right" end>
                                        <DropdownItem className="container" href="/myphoenix" id="myPhoenixHomeLink">My Phoenix</DropdownItem>
                                        <DropdownItem className="container" onClick={this.handleLogout} id="logoutButton">Logout</DropdownItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
